import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';
import type {
  TAPITAPIChangeDeveloperStatusResponse,
  TAPIChangeDeveloperStatus,
} from './developer-status-change.types';

export const useAPIChangeStatusDeveloper = (): TAPIChangeDeveloperStatus => {
  const { data, error, put, response, loading } = useFetch(
    API_ROUTES.DEVELOPERS,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const changeDeveloperStatus = async (idDeveloper:string): Promise<TAPITAPIChangeDeveloperStatusResponse> => {
    return put(`/${idDeveloper}`);
  };

  return {
    data: data?.data,
    error,
    loaded: response?.ok,
    loading,
    changeDeveloperStatus,
  };
};